export const ValuePopupPosX = 55
export const config = {
  intro: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#ffd500',
      '#ffc800',
      '#ffa200',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  symbolValue: {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowDistance: 2,
    fill: [
      '#ca3fc6',
      '#3fabc6',
    ],
    strokeThickness: 3,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
}
